// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2H9Q6","overflowing":"ReadFullNote_overflowing__1pt6e"};